import { createAction, asError } from 'redux-act';


/* Locale */
export const set_locale = createAction('Set Locale');


/* Login */
export const set_current_user = createAction('Set Current User');
export const clear_current_user = createAction('Clear User');
export const set_axios_instace = createAction('Set Axios Instance');
export const set_cache_instance = createAction('Set Cache Instance');


/* Search */
export const set_loaded_people = createAction('Set Loaded People');


/* STP Items */
export const set_loaded_stp_items = createAction('Set Loaded STP Items');
export const save_stp_form = createAction('Save STP Form');
export const remove_stp_form = createAction('Remove STP Form');
export const submit_stp_form = createAction('Submit STP Form');

/* Forms Items */
export const set_loaded_forms_items = createAction('Set Loaded Forms Items');
export const save_forms_form = createAction('Save Forms Form');
export const remove_forms_form = createAction('Remove Forms Form');
export const submit_forms_form = createAction('Submit Forms Form');


/* Reports */
export const set_reports = createAction('Set Reports');
export const add_reports = createAction('Add Reports');
export const set_partial_reports = createAction('Set patial query executed flag');
export const clear_partial_reports = createAction('Clear patial query execution flag');

export const save_report = createAction('Submit Report');
export const submit_report = createAction('Submit Report');
export const remove_report = createAction('Remove Report');


/* Luts */
export const load_table = createAction('Load a lookup table');
export const load_complex_table = createAction('Load a complex lookup table');


/* Notifications */
export const dismiss_notification = createAction('Dismiss Notifications');
export const throw_error = asError(createAction('Throw Error Notification'));

/* System Settings */
export const set_system_settings = createAction('Set System Settings');
export const fetch_system_settings = createAction('Fetch System Settings');